import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { match } from 'react-router'

import State from '../states'
import PhotoModal, { Props } from '../components/PhotoModal'
import { Comment, Photo } from '../actions'
import { Image } from '../states/WorldState'
import { PhotoProps } from '../states/RouterState'

const mapStateToProps = (state: State): Partial<Props> => {
  const photoID = state.ui.photoID!
  // TODO: what if this is not an image?
  // TODO: what if image not loaded?
  const mapObjectState = state.world.mapObjects[photoID]
  if (!mapObjectState) {
    return { id: photoID }
  }
  const image = mapObjectState.mapObject as Image
  const comments = state.comment.comments[photoID]
  return {
    id: photoID,
    photo: image.normalURL,
    thumbnail: image.thumbnailURL,
    loved: image.loved,
    author: image.name,
    note: image.note,
    comments: comments
      ? comments.map(comment => ({
          id: comment.id,
          name: comment.name,
          content: comment.content
        }))
      : []
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<State>,
  ownProps: { match: match<PhotoProps> }
): Partial<Props> => ({
  onClose: () => {
    dispatch(Photo.closeModal())
  },
  onLove: () => {
    dispatch(Photo.loveTapped())
  },
  onComment: content => {
    dispatch(
      Comment.submitPhotoComment({
        id: ownProps.match.params.id,
        content
      })
    )
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(PhotoModal)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PhotoModal.ts